import React, { ReactElement } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { MapState } from '../../map/reducer';
import { updateFilterTextAction } from '../../map/actions';

export default function Search(): ReactElement {
  const { filterText } = useSelector((state: { map: MapState }) => ({ filterText: state.map.filterText }));
  const dispatch = useDispatch();
  return (
    <div className="contextual-region block block-sidebar-first hb-container closed">
      <div className="block-title">
        <h3>
          <span className="disable-select">Sök</span>
          <div className="hb-toggle-trigger">
            <div className="hb-toggle">
              <div className="hb-toggle-icon" />
            </div>
          </div>
        </h3>
      </div>

      <div className="block-content-outer hb-item-content">
        <div className="block-content hb-item-content-inner">
          <form method="get" id="views-exposed-form-buoys-all" acceptCharset="UTF-8">
            <div className="form--inline clearfix">
              <div className="js-form-item form-item js-form-type-textfield form-type-textfield js-form-item-title form-item-title">
                <label htmlFor="edit-title">Rubrik</label>
                <input
                  type="text"
                  id="edit-title"
                  name="title"
                  value={filterText}
                  onChange={(e) => {
                    dispatch(updateFilterTextAction(e.target.value));
                  }}
                  size={30}
                  maxLength={128}
                  className="form-text"
                />

                <div id="edit-title--description" className="description">
                  Skriv för att fritextsöka
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
